/**
 * Cross-check solution identifiers for the Word add-in.
 *
 * Table-row track-change support (merged row client requests, OOXML table
 * navigation, row clause labels) is Master Cross Checks (MCC) only.
 * Construction Loan must keep the legacy body-paragraph behaviour.
 */

export type CrossCheckSolution = 'mcc' | 'construction_loan';

export function crossCheckSolutionFromDomain(
  domain: 'construction-loan' | 'real-estate' | null | undefined,
): CrossCheckSolution {
  return domain === 'construction-loan' ? 'construction_loan' : 'mcc';
}

export function crossCheckSolutionFromKebabVariant(
  variant: 'mcc' | 'construction-loan' | undefined,
): CrossCheckSolution {
  return variant === 'construction-loan' ? 'construction_loan' : 'mcc';
}

/** True when table-row TC features (row merge, table navigation, row labels) may run. */
export function isMccTableRowSupportEnabled(
  solution: CrossCheckSolution | null | undefined,
): boolean {
  return solution === 'mcc';
}

export type CrossCheckFeatureContext = {
  solution?: CrossCheckSolution;
};
